import style from './GheFuncoes.module.css';

import SmallLoading from '../../Utils/SmallLoading';
import FilterContainer from '../../Utils/FilterContainer';

import axios from 'axios';
import React, { useCallback, useContext, useEffect, useState } from 'react';

import { MdModeEdit } from "react-icons/md";
import Overlay from '../../Overlay';
import FormContainer from '../../Utils/FormContainer';
import FormComp from '../../FormComp';
import { AuthContext } from '../../../Auth/AuthProvider';
import { VerifyPermission } from '../../../Funcoes/VerifyPermission';
import ModalListaGHE from '../../../Modulos/PainelCtrl/ModalListaGHE';
import { useModal } from '../../../contexts/ModalContext';


const GheFuncoes = () => {

    const { user } = useContext(AuthContext)

    const { openModal, isModalOpen } = useModal();

    const [responseData, setResponseData] = useState([])
    const [responseDataFilter, setResponseDataFilter] = useState([])

    const [funcoes, setFuncoes] = useState([])
    const [ghes, setGhes] = useState([])

    const [funcaoVal, setFuncaoVal] = useState([])
    const [gheVal, setGheVal] = useState([])

    const [editMode, setEditionMode] = useState(false)

    const [info, setInfo] = useState({
        funcao: '',
        ghe: ''
    })

    const [loading, setLoading] = useState(true);

    const [ ghesList, setGhesList ] = useState([]);

    const getValues = async () => {

        setLoading(true);

        try {

            const [ funcoesResponse, GHEResponse ] = await Promise.all([
                axios.get( 'https://sistemaintegrado.palmont.com.br/Painel/API/InfoPanel/Funcoes_GHE/', { withCredentials: true }),
                axios.get( 'https://sistemaintegrado.palmont.com.br/Painel/API/InfoPanel/GHEList/', { withCredentials: true })
            ])

            const funcoesData = funcoesResponse.data

            setResponseData(funcoesData);
            setResponseDataFilter(funcoesData);

            setFuncoes([... new Set(funcoesData.map(item => item.FUNCAO).sort())])
            setGhes(["PENDENTES", ... new Set( ghesList.map( obj => obj.nome ).sort())])

            const GHEData = GHEResponse.data

            setGhesList( GHEData )


        } catch (error) {

            console.log(error);

        } finally {

            setLoading(false);

        }

    }

    useEffect(() => {

        getValues();

    }, [])

    const openEdit = (funcao, ghe) => {

        setEditionMode(true);
        setInfo({
            funcao: funcao,
            ghe: ghe === null ? '' : ghe
        });

    };

    const closeEdit = () => {

        setEditionMode(false);
        setInfo({
            funcao: '',
            ghe: ''
        })

    }

    const handleFilter = useCallback(() => {

        setResponseDataFilter(
            responseData.filter((item) => {

                const funcFilter = !funcaoVal.length || funcaoVal.some(obj => (item.FUNCAO || '').includes(obj.value))
                const gheFilter = !gheVal.length || gheVal.some(obj => {
                    if (obj.value === 'PENDENTES') return item.GHE === null
                    return (item.GHE || '').includes(obj.value);
                })

                return funcFilter && gheFilter

            })
        )

    }, [funcaoVal, gheVal])

    useEffect(() => {

        handleFilter()

    }, [handleFilter])

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            const formData = new FormData();
            formData.append('FUNCAO', info.funcao);
            formData.append('GHE', info.ghe);

            await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/InfoPanel/SaveGhePanel/', formData);

            await getValues();
            closeEdit();

        } catch (e) {

            console.error(e);

        }

    }

    const openCreateGHE = () => {

        openModal("listaGhes")

    }

    return (
        <>
            {loading
                ? <SmallLoading />
                :
                <>
                    <div className={ style.headTitle } >
                        <p className={style.title} >FUNÇÕES x GHE</p>
                        {
                            VerifyPermission( user, { modulo: 'ssma', submodulo: 'painel-ctrl', funcao: 'manage-ghe' } ) &&
                            <button
                                className={ style.btnCreate }
                                onClick={() => openCreateGHE() }
                            >
                                LISTA GHE
                            </button>
                        }
                    </div>

                    <div className={style.containerFilters} >
                        <FilterContainer
                            type="select"
                            placeholder="FUNÇÃO..."
                            options={funcoes}
                            optType="obj"
                            valor={funcaoVal}
                            changeFunc={(selected) => setFuncaoVal(selected)}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="GHE..."
                            options={[ "PENDENTES", ... new Set( ghesList.map( obj => obj.nome ).sort())]}
                            optType="obj"
                            valor={gheVal}
                            changeFunc={(selected) => setGheVal(selected)}
                        />
                    </div>
                    <div className={style.container} >
                        <table>
                            <thead>
                                <tr>
                                    <th className={style.funcCol} >FUNÇÃO</th>
                                    <th className={style.gheCol} >GHE</th>
                                    <th className={style.editCol} ></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    responseDataFilter.map(( obj, index ) => (
                                        <tr key={ index } className={style.linhaTable} >
                                            <td>{obj.FUNCAO}</td>
                                            <td>{obj.GHE ? obj.GHE : '-'}</td>
                                            <td className={style.editCol} >
                                                {
                                                    VerifyPermission( user, { modulo: 'ssma', submodulo: 'painel-ctrl', funcao: 'edit-ghexfuncao' }) && (
                                                        <div
                                                            className={style.editContainer}
                                                            onClick={() => openEdit(obj.FUNCAO, obj.GHE)}
                                                        >
                                                            <MdModeEdit className={style.editIcon} />
                                                        </div>
                                                    )
                                                }
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </>
            }
            <Overlay state={editMode} >
                <FormContainer closeFunc={closeEdit} >
                    <form onSubmit={handleSubmit} >
                        <FormComp
                            title="FUNCÃO"
                            type="text"
                            valor={info.funcao}
                            readOnly
                        />
                        <FormComp
                            title="GHE"
                            type="select"
                            options={[
                                ... new Set( ghesList.map( obj => obj.nome ).sort() )
                            ]}
                            valor={info.ghe}
                            changeFunc={(e) => setInfo({ ...info, ghe: e.target.value })}
                            required
                        />
                        <FormComp
                            type="submit"
                            valor="SALVAR"
                        />
                    </form>
                </FormContainer>
            </Overlay>
            {
                isModalOpen("listaGhes") && (
                    <ModalListaGHE />
                )
            }
        </>
    )

}

export default GheFuncoes;